// Bottom-docked bundle widget for collection pages. Reads the in-progress bundle from
// sessionStorage (drool_bundle_v1 — same key the bundle builder persists). Collapsed = a
// full-width yellow bar with a dynamic "you're X away" message; expanded = a white panel
// with the bundle thumbnails, the running Total (struck + discounted + SAVE pill) and a
// black pill CTA. (Figma 115-2087 open / 115-1940 closed.)
const KEY = 'drool_bundle_v1';
const COLLAPSE_KEY = 'drool_bw_collapsed';

// Savings tooltip — SAME copy as the PDP "SAVE X" tooltip (feedback 6).
const SAVE_TOOLTIP = 'Savings are based on pack discount and the value of free medium print(s).';
const SAVE_ICON = '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.3"/><path d="M8 7v4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/><circle cx="8" cy="4.7" r="0.9" fill="currentColor"/></svg>';

// Bundle tiers. The real values come from the shared Theme Setting "Bundle Builder Offer",
// injected on <bundle-widget data-tier-config> by the snippet (single source, market-resolved).
// These are only a fallback if that attribute is missing/unparseable.
const DEFAULT_TIERS = { duo: { paid: 2, free: 2, disc: 20 }, quad: { paid: 3, free: 3, disc: 22 }, gallery: { paid: 4, free: 4, disc: 24 } };

function parseTiers(str) {
  try {
    const c = JSON.parse(str);
    if (c && c.duo && c.quad && c.gallery) {
      // Ensure fixed paid counts even if the JSON omits them.
      c.duo.paid = 2; c.quad.paid = 3; c.gallery.paid = 4;
      return c;
    }
  } catch (e) {}
  return DEFAULT_TIERS;
}
function tierSteps(tiers) {
  return [
    { count: tiers.duo.paid, discount: tiers.duo.disc, free: tiers.duo.free },
    { count: tiers.quad.paid, discount: tiers.quad.disc, free: tiers.quad.free },
    { count: tiers.gallery.paid, discount: tiers.gallery.disc, free: tiers.gallery.free },
  ];
}

function loadBundle() {
  try {
    const d = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    return d && d.ts ? d : null;
  } catch (e) {
    return null;
  }
}

function money(cents) {
  const code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
  try {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: code, minimumFractionDigits: (cents % 100 ? 2 : 2) }).format(cents / 100);
  } catch (e) {
    return '£' + (cents / 100).toFixed(2);
  }
}

function variantPrice(product, size, frame) {
  if (!product || !product.variants || !product.variants.length) return 0;
  let v = product.variants.find((x) => x.option1 === size && x.option2 === frame)
    || product.variants.find((x) => x.option1 === size)
    || product.variants[0];
  return v ? v.price : 0;
}

function paidSlots(data) {
  if (!data) return [];
  const slots = (data.paidSlots || []).filter((s) => s && s.assigned && s.product);
  const overflow = (data.overflow || []).filter((o) => o && o.product).map((o) => ({ assigned: true, product: o.product, size: o.size, frame: o.frame }));
  return slots.concat(overflow);
}
function freeSlots(data) {
  if (!data) return [];
  return (data.freeSlots || []).filter((s) => s && s.assigned && s.product);
}

function nextTier(n, steps) {
  for (const t of steps) if (n < t.count) return { ...t, away: t.count - n };
  return null;
}

function message(n, steps) {
  const top = steps[steps.length - 1]; // best tier (maxed copy)
  // (a) empty
    if (n === 0) return `You’re 2 prints away from ${steps[0].discount}% off and 2 free prints`;
  const t = nextTier(n, steps);        // next tier not yet reached (null once maxed)
  // (d) maxed out
  if (!t) return `Nice! You’ve unlocked ${top.discount}% off + ${top.free} free prints`;
  // (c) has already unlocked a discount (reached at least one tier) but isn't maxed
  const current = steps.slice().reverse().find((s) => n >= s.count) || null;
  if (current) {
    return `You’ve unlocked ${current.discount}% off and ${current.free} free print${current.free > 1 ? 's' : ''}`;
  }
  // (b) not yet unlocked — distance to the first tier
  const noun = t.away === 1 ? 'print' : 'prints';
  let msg = `You’re ${t.away} ${noun} away from ${t.discount}% off`;
  if (t.free > 0) msg += ` and ${t.free} free print${t.free > 1 ? 's' : ''}`;
  return msg;
}

function thumb(print, isFree, empty) {
  const inCart = !!(print && print._inCart);
  const el = document.createElement('div');
  el.className = 'bundle-widget__item' + (isFree ? ' bundle-widget__item--free' : '') + (empty ? ' bundle-widget__item--empty' : '') + (inCart ? ' bundle-widget__item--incart' : '');
  if (empty) {
    el.innerHTML = '<span class="bundle-widget__item-plus">+</span>';
    return el;
  }
  const src = print && print.image;
  if (src) {
    const img = document.createElement('img');
    img.src = src;
    img.alt = print.title || '';
    img.loading = 'lazy';
    el.appendChild(img);
  }
  // "In cart" badge (feedback) — same treatment the removed "FREE" tag used on the thumbnail.
  if (inCart) {
    const badge = document.createElement('span');
    badge.className = 'bundle-widget__item-incart';
    badge.textContent = 'In cart';
    el.appendChild(badge);
  }
  return el;
}

// In-progress prints from the saved bundle, normalised to {image, title, price}.
function sessionPrints(data) {
  const map = (s) => ({ image: (s.product && (s.product.image || s.product.artImage)) || null, title: s.product && s.product.title, price: variantPrice(s.product, s.size, s.frame) });
  return { paid: paidSlots(data).map(map), free: freeSlots(data).map(map), tier: data && data.tier };
}

// ALL prints in the CART count toward the pack — not just ones added via the bundle (item GA).
// A print added via the normal PDP or the PLP Quick-Add has no `_bundle_type`, but it's still a
// print in the cart, so it must appear here. We include every "Print"-type line, and exclude the
// physical frame + framing-service child lines (and any £0 non-bundle gift/upsell line).
async function cartPrints() {
  try {
    const cart = await fetch('/cart.js', { cache: 'no-store' }).then((r) => r.json());
    const paid = [], free = [];
    let tier = null;
    (cart.items || []).forEach((i) => {
      const pr = i.properties || {};
      if (pr._bundle_type) tier = tier || pr._bundle_type;
      const type = (i.product_type || '').toLowerCase();
      const title = i.product_title || i.title || '';
      const isPrint = type.indexOf('print') > -1; // catalogue prints are type "Print"
      if (!isPrint) return;                         // skip frames, framing service, hooks, etc.
      if (/framing service/i.test(title)) return;
      const price = i.original_price || i.price || 0;
      const obj = { image: i.image || i.featured_image || null, title: i.product_title || i.title || '', price, _inCart: true };
      if (pr._bundle_free === 'true') free.push(obj);
      else if (price > 0) paid.push(obj);           // ignore £0 non-bundle gift lines
    });
    return { paid, free, tier };
  } catch (e) { return { paid: [], free: [], tier: null }; }
}

// Union of two print lists, de-duped by title+price so cart + in-progress don't double up.
function mergePrints(a, b) {
  const seen = new Set(), out = [];
  [...(a || []), ...(b || [])].forEach((p) => { const k = (p.title || '') + '|' + (p.price || 0); if (!seen.has(k)) { seen.add(k); out.push(p); } });
  return out;
}

class BundleWidget extends HTMLElement {
  connectedCallback() {
    this.tiers = parseTiers(this.dataset.tierConfig);   // shared offer config (item: single source)
    this.tierSteps = tierSteps(this.tiers);
    this.panel = this.querySelector('[data-bw-panel]');
    this.bar = this.querySelector('[data-bw-toggle]');
    this.barText = this.querySelector('[data-bw-bartext]');
    this.basePrice = Number(this.dataset.basePrice) || 2800; // base print price (cents) for the "from" teaser
    this.itemsEl = this.querySelector('[data-bw-items]');
    this.saveEl = this.querySelector('[data-bw-save]');
    this.totalEl = this.querySelector('[data-bw-total]');
    this.totalLabelEl = this.querySelector('.bundle-widget__total-label');
    this.closeBtn = this.querySelector('[data-bw-close]');
    this.cta = this.querySelector('[data-bw-cta]');
    this.viewEl = this.querySelector('[data-bw-view]');

    this.bar.addEventListener('click', () => this.toggle());
    if (this.closeBtn) this.closeBtn.addEventListener('click', (e) => { e.stopPropagation(); this.setOpen(false, true); });

    this.render();
    this.removeAttribute('hidden');

    window.addEventListener('pageshow', () => this.render());
    window.addEventListener('storage', (e) => { if (e.key === KEY) this.render(); });
    // Reflect cart adds/removes (item F4). The theme fires BOTH 'cart:update' (CartUpdateEvent) and
    // 'cart:updated' depending on the path — desktop removal fired one, the mobile cart the other, so
    // the widget went stale on mobile (feedback). Listen to both. Also re-render when the tab regains
    // focus / becomes visible, in case a removal happened on a separate /cart page.
    document.addEventListener('cart:update', () => this.render());
    document.addEventListener('cart:updated', () => this.render());
    window.addEventListener('focus', () => this.render());
    document.addEventListener('visibilitychange', () => { if (!document.hidden) this.render(); });
  }

  async render() {
    const sess = sessionPrints(loadBundle());
    const cart = await cartPrints();                 // include what's already in the cart (item F4)
    let paid = mergePrints(cart.paid, sess.paid);
    let free = mergePrints(cart.free, sess.free);
    const n = paid.length;
    const hasBundle = n > 0 || free.length > 0;

    this.barText.textContent = message(n, this.tierSteps);

    // Tier config: prefer the cart/saved tier, else infer from paid count.
    const tier = this.tiers[cart.tier || sess.tier] || (n >= 4 ? this.tiers.gallery : n === 3 ? this.tiers.quad : this.tiers.duo);

    // Any print beyond the tier's PAID quota fills a FREE slot — so a 3rd print lands in the
    // "free print" slot rather than an extra paid slot, however it was added (feedback 2).
    if (paid.length > tier.paid) {
      free = paid.slice(tier.paid).concat(free);
      paid = paid.slice(0, tier.paid);
    }

    // Thumbnails: EVERY print the shopper has (paid + free) always renders, plus dashed empties
    // up to the tier capacity. Use max() so a print is never dropped even if it exceeds the
    // (possibly stale) hardcoded tier count — this was hiding the free prints (item F4).
    this.itemsEl.innerHTML = '';
    const paidSlotsN = Math.max(tier.paid, paid.length);
    for (let i = 0; i < paidSlotsN; i++) {
      this.itemsEl.appendChild(paid[i] ? thumb(paid[i], false, false) : thumb(null, false, true));
    }
    const freeSlotsN = Math.max(tier.free, free.length);
    for (let i = 0; i < freeSlotsN; i++) {
      this.itemsEl.appendChild(free[i] ? thumb(free[i], true, false) : thumb(null, true, true));
    }

    // Running total: paid prints discounted; free prints struck-through value on top.
    const paidOriginal = paid.reduce((sum, p) => sum + (p.price || 0), 0);
    const freeValue = free.reduce((sum, p) => sum + (p.price || 0), 0);
    let sale = Math.round(paidOriginal * (1 - tier.disc / 100));
    let struck = paidOriginal + freeValue;
    let fromPrefix = '';
    if (!hasBundle) {
      // Empty state (item G4): a "From <s>£56</s> £44.80" teaser = the entry (duo) pack at the
      // base print price.
      const duo = this.tiers.duo;
      struck = duo.paid * this.basePrice;
      sale = Math.round(struck * (1 - duo.disc / 100));
      fromPrefix = '<span class="bundle-widget__from">From</span> ';
    }
    const save = struck - sale;
    if (this.totalEl) {
      this.totalEl.innerHTML = fromPrefix + (struck > sale ? '<s>' + money(struck) + '</s> ' : '') + money(sale);
    }
    if (this.totalLabelEl) this.totalLabelEl.style.display = hasBundle ? '' : 'none'; // "Total" hidden on the "From" teaser
    this.dataset.state = hasBundle ? 'total' : 'from'; // drives the mobile CTA layout (feedback): From = beside price, Total = own row
    if (this.saveEl) {
      if (!hasBundle || save <= 0) {
        this.saveEl.innerHTML = '';
        this.saveEl.style.display = 'none';
      } else {
        this.saveEl.innerHTML = 'SAVE ' + money(save)
          + '<span class="bundle-widget__save-info" tabindex="0" role="button" aria-label="How savings are calculated">'
          + SAVE_ICON
          + '<span class="bundle-widget__save-tip" role="tooltip">' + SAVE_TOOLTIP + '</span></span>';
        this.saveEl.style.display = '';
        const info = this.saveEl.querySelector('.bundle-widget__save-info');
        if (info) {
          const closeOnOutside = (ev) => { if (!info.contains(ev.target)) { info.classList.remove('is-open'); document.removeEventListener('click', closeOnOutside); } };
          info.addEventListener('click', (e) => {
            e.stopPropagation();
            if (info.classList.contains('is-open')) {           // open → clicking it again closes
              info.classList.remove('is-open');
              document.removeEventListener('click', closeOnOutside);
            } else {                                             // closed → open + close on any outside click/tap
              info.classList.add('is-open');
              setTimeout(() => document.addEventListener('click', closeOnOutside), 0);
            }
          });
        }
      }
    }

    if (this._initialised) return;
    this._initialised = true;
    // Always start collapsed — the widget only opens when the shopper taps the bar (feedback).
    this.setOpen(false, false);
  }

  toggle() { this.setOpen(this.dataset.open !== 'true', true); }

  setOpen(open, remember) {
    this.dataset.open = open ? 'true' : 'false';
    this.bar.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (remember) {
      try { sessionStorage.setItem(COLLAPSE_KEY, open ? '0' : '1'); } catch (e) {}
    }
  }
}

if (!customElements.get('bundle-widget')) customElements.define('bundle-widget', BundleWidget);
